"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _utils = require("../../../utils");
var _CardNumber = _interopRequireDefault(require("./CardNumber"));
var _CardExpiry = _interopRequireDefault(require("./CardExpiry"));
var _CardCvc = _interopRequireDefault(require("./CardCvc"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ElementsNames = {
  number: 'number',
  expiry: 'expiry',
  cvc: 'cvc',
  // single card element
  card: 'card'
};
var getErrorMessage = function getErrorMessage(error, complete) {
  if (error) {
    return error.message;
  }
  if (!complete) {
    return 'A payment method is required.';
  }
  return null;
};
var StripeCard = function StripeCard(_ref) {
  var _useState9;
  var _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? _utils.StripeCheckoutModes.Card : _ref$mode,
    _ref$cardElementOptio = _ref.cardElementOptions,
    cardElementOptions = _ref$cardElementOptio === void 0 ? {
      hidePostalCode: true
    } : _ref$cardElementOptio,
    style = _ref.style,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError;
  var elements = (0, _reactStripeJs.useElements)();
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    complete = _useState2[0],
    setComplete = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = (0, _react.useState)((_useState9 = {}, _defineProperty(_useState9, ElementsNames.number, false), _defineProperty(_useState9, ElementsNames.expiry, false), _defineProperty(_useState9, ElementsNames.cvc, false), _useState9)),
    _useState8 = _slicedToArray(_useState7, 2),
    setCompletionMap = _useState8[1];
  var handleSingleElementChange = function handleSingleElementChange(e, elementName) {
    var complete = false;
    setCompletionMap(function (current) {
      var map = _objectSpread(_objectSpread({}, current), {}, _defineProperty({}, elementName, e.complete));
      complete = (0, _lodash.every)((0, _lodash.values)(map), function (v) {
        return v;
      });
      return map;
    });
    setError(e.error);
    setComplete(complete);
    setErrorMessage(null);
    _onChange(e, elementName, complete);
  };
  var onBlur = function onBlur() {
    if (showError) {
      setErrorMessage(getErrorMessage(error, complete));
    }
  };
  var Error = errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-error"
  }, errorMessage);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mode === _utils.StripeCheckoutModes.Card ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-element-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardElement, {
    className: "ant-input",
    style: style,
    options: _objectSpread(_objectSpread({}, cardElementOptions), {}, {
      style: (0, _lodash.set)((0, _lodash.cloneDeep)(style), 'base.::placeholder.color', '#333')
    }),
    onReady: function onReady() {
      if (autoFocus) {
        elements.getElement(_reactStripeJs.CardElement).focus();
      }
    },
    onChange: function onChange(e) {
      setError(e.error);
      setComplete(e.complete);
      setErrorMessage(null);
      _onChange(e, ElementsNames.card, e.complete);
    },
    onBlur: onBlur,
    focus: false
  })), Error) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-element-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_CardNumber.default, {
    onChange: function onChange(e) {
      handleSingleElementChange(e, ElementsNames.number);
    },
    onBlur: onBlur,
    style: style
  }), /*#__PURE__*/_react.default.createElement(_CardExpiry.default, {
    onChange: function onChange(e) {
      handleSingleElementChange(e, ElementsNames.expiry);
    },
    onBlur: onBlur,
    style: style
  }), /*#__PURE__*/_react.default.createElement(_CardCvc.default, {
    onChange: function onChange(e) {
      handleSingleElementChange(e, ElementsNames.cvc);
    },
    onBlur: onBlur,
    style: style
  })), Error));
};
var _default = StripeCard;
exports.default = _default;